export const GET_COUNTRIES = "GET_COUNTRIES";
export const GET_COUNTRY = "GET_COUNTRY";
export const COUNTRY_NAME = "COUNTRY_NAME";
export const POST_ACTIVITIES = "POST_ACTIVITIES";
export const GET_ACTIVITIES = "GET_ACTIVITIES";
export const FILTER_CONTINENT = "FILTER_CONTINENT";
export const ORDER_COUNTRY = "ORDER_COUNTRY";
export const ORDER_POPULATION = "ORDER_POPULATION";
export const FILTER_ACTIVITY_SEASON = "FILTER_ACTIVITY_SEASON";
export const GET_COUNTRY_NAME = "GET_COUNTRY_NAME";
export const CLEAN_DETAIL = "CLEAN_DETAIL";
export const GET_COUNTRY_ACTIVITY = "GET_COUNTRY_ACTIVITY";
export const FILTER_BY_ACTIVITY = "FILTER_BY_ACTIVITY";
